import { AddressDto } from "./address.dto";

export interface UserDto {
  name: string;
  surname: string;
  email: string;
  phonePrefix: string;
  phoneNumber: string;
  address: AddressDto;
  birthdate: string;
  additionalData: FidelityCustomerFieldCreationRequest[];
  privacyPolicy: FidelityCustomerFieldCreationRequest[];
  [key: string]: any;
}

export interface FidelityCustomerField {
  id: string;
  configFieldId: string;
  name: string;
  value: string;
}

export interface FidelityCustomerFieldCreationRequest
  extends Omit<FidelityCustomerField, "id"> {}


export function initializeUser(): UserDto {
  return {
    name: "Bob",
    surname: "",
    email: "",
    phonePrefix: "",
    phoneNumber: "",
    address: {
      country: "",
      countryShort: "",
      areaLevel1: "",
      areaLevel2: "",
      areaLevel2Short: "",
      areaLevel3: "",
      locality: "",
      route: "",
      streetNumber: "",
      postalCode: "",
      formattedAddress: "",
      extension: "",
    },
    birthdate: "",
    additionalData: [],
    privacyPolicy: [],
  };
}

export function mapPlaceToAddress(
  place: google.maps.places.PlaceResult
): AddressDto {
  const addressComponents = place.address_components;

  const address: AddressDto = {
    country: "",
    countryShort: "",
    areaLevel1: "",
    areaLevel2: "",
    areaLevel2Short: "",
    areaLevel3: "",
    locality: "",
    route: "",
    streetNumber: "",
    postalCode: "",
    formattedAddress: place.formatted_address || "",
    extension: "",
  };

  addressComponents?.forEach((component) => {
    const componentType = component.types[0];

    switch (componentType) {
      case "country":
        address.country = component.long_name;
        address.countryShort = component.short_name;
        break;
      case "administrative_area_level_1":
        address.areaLevel1 = component.long_name;
        break;
      case "administrative_area_level_2":
        address.areaLevel2 = component.long_name;
        break;
      case "administrative_area_level_3":
        address.areaLevel3 = component.long_name;
        break;
      case "locality":
        address.locality = component.long_name;
        break;
      case "route":
        address.route = component.long_name;
        break;
      case "street_number":
        address.streetNumber = component.long_name;
        break;
      case "postal_code":
        address.postalCode = component.long_name;
        break;
      case "sublocality_level_1":
        address.areaLevel2Short = component.long_name;
        break;
      case "extended_address":
        address.extension = component.long_name;
        break;
    }
  });

  return address;
}
